export const availableLanguages = [
	'en',
	'es',
	'ca',
	'eu',
	'gl',
	'de',
	'fr',
	'ko',
	'zh',
	'ja',
	'pt',
	'ru',
	'it',
	'nl',
	'el',
];

export const defaultLocale = 'es';
